// src/store/rootReducer.js:
import { combineReducers } from "redux";
import chatMssageReducer from "./features/message/messageSlice";
import textContentReducer from "./features/message/textContentSlice";
import uiReducer from "./features/ui/uiSlice";

const appReducer = combineReducers({
  messages: chatMssageReducer,
  textContent: textContentReducer,
  ui: uiReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
